import { render, staticRenderFns } from "./OurFacilities.vue?vue&type=template&id=0c6b7b97&scoped=true"
import script from "./OurFacilities.vue?vue&type=script&lang=js"
export * from "./OurFacilities.vue?vue&type=script&lang=js"
import style0 from "./OurFacilities.vue?vue&type=style&index=0&id=0c6b7b97&prod&scoped=true&lang=css"
import style1 from "./OurFacilities.vue?vue&type=style&index=1&id=0c6b7b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b7b97",
  null
  
)

export default component.exports